//Module Keys
let locales = {};

//Merge Views
import maintenanceWarningEventsMain from 'Modules/maintenanceWarningEvents/views/main/lan/en';

locales = { 
    ...locales, 
    ...maintenanceWarningEventsMain
};

export default locales;